export enum DialogVariant {
	secondary = 'secondary'
}